import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { KeyRound, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  return String(d);
}

export default function UserResetPassword() {
  const nav = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("La password deve avere almeno 8 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/user-auth/reset-password`, { token, password });
      toast.success(r.data?.message || "Password aggiornata");
      setTimeout(() => nav("/utente/login"), 800);
    } catch (err) {
      toast.error(formatErr(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="user-reset-password-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8">
        <p className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold mb-1">Unioncasa · Pannello Associato</p>
        <h1 className="text-2xl font-serif text-slate-900 mb-2">Imposta una nuova password</h1>
        <p className="text-sm text-slate-600 mb-6">
          Scegli una password sicura di almeno 8 caratteri. Una volta salvata, potrai accedere subito con le nuove credenziali.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Nuova password</label>
            <div className="relative">
              <KeyRound size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                className="w-full h-10 pl-9 pr-3 border border-slate-300 rounded-md focus:outline-none focus:border-slate-900 text-sm"
                data-testid="reset-password-input" required minLength={8} />
            </div>
            <p className="text-[11px] text-slate-500 mt-1">Minimo 8 caratteri.</p>
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Conferma password</label>
            <div className="relative">
              <KeyRound size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)}
                className="w-full h-10 pl-9 pr-3 border border-slate-300 rounded-md focus:outline-none focus:border-slate-900 text-sm"
                data-testid="reset-password-confirm-input" required minLength={8} />
            </div>
          </div>
          <button type="submit" disabled={busy}
            className="w-full h-11 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-black disabled:opacity-60"
            data-testid="reset-submit-btn">
            {busy ? "Aggiornamento..." : "Salva nuova password"}
          </button>
        </form>

        <p className="text-xs text-slate-600 mt-6 text-center">
          <Link to="/utente/login" className="inline-flex items-center gap-1 text-slate-900 font-medium hover:underline">
            <ArrowLeft size={12} /> Torna al login
          </Link>
        </p>
      </div>
    </div>
  );
}
